import React from "react";
import { useMessageSource } from "react-message-source";
import DatePicker from "../formik/text-input/date";

interface BirthDateType {
  value: string;
  dataPath: string;
}

export default function BirthDate({
  value,
  dataPath = "",
}: BirthDateType): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <div>
      <DatePicker
        id={`${dataPath}birthdate`}
        name={`${dataPath}birthdate`}
        value={value}
        label={getMessage("Person.birthDate")}
        shrink={Boolean(value)}
      />
    </div>
  );
}
